import React, { useState } from 'react';
import '../styles/Testimonials.css';
import QuoteModal from './QuoteModal';

const Testimonials = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  const testimonials = [
    {
      id: 1,
      name: 'Dr. Rajesh Mehta',
      position: 'Founder, HearClear Clinic',
      location: 'Mumbai',
      rating: 5,
      text: 'The instant replacement policy alone saved us from 20+ angry customers. Their support team actually picks up the phone. Best decision we ever made for our clinic.',
      image: '/assets/testimonial1.jpg',
      businessType: 'Hearing Clinic'
    },
    {
      id: 2,
      name: 'Priya Sharma',
      position: 'Director, SoundCare Distributors',
      location: 'Delhi NCR',
      rating: 5,
      text: 'Low MOQ helped us start small. Now we are their top distributor in North India. The custom branding option is a game changer for our business.',
      image: '/assets/testimonial2.jpg',
      businessType: 'Distributor'
    },
    {
      id: 3,
      name: 'Dr. Anil Kumar',
      position: 'Owner, Advanced Hearing Solutions',
      location: 'Bangalore',
      rating: 5,
      text: '15 days delivery commitment is real. We never faced stockout issues. Their clinic support program helped us train our staff effectively.',
      image: '/assets/testimonial3.jpg',
      businessType: 'Hearing Clinic'
    },
    {
      id: 4,
      name: 'Suresh Reddy',
      position: 'Managing Director, HearWell Retail',
      location: 'Hyderabad',
      rating: 5,
      text: 'Quality is premium but prices are affordable. Our customers love the products. The BYOB program helped us create our own brand identity.',
      image: '/assets/testimonial4.jpg',
      businessType: 'Retail Chain'
    },
    {
      id: 5,
      name: 'Dr. Neha Gupta',
      position: 'Founder, Ear Care Clinic',
      location: 'Pune',
      rating: 5,
      text: 'Pan-India support is fantastic. Wherever our patients travel, they get service. This trust factor alone increased our patient retention by 40%.',
      image: '/assets/testimonial5.jpg',
      businessType: 'Hearing Clinic'
    },
    {
      id: 6,
      name: 'Vikram Singh',
      position: 'CEO, HealthFirst Medicals',
      location: 'Ahmedabad',
      rating: 5,
      text: 'The margins are better than any other brand we have worked with. Plus the marketing support helps us sell more. Highly recommended.',
      image: '/assets/testimonial6.jpg',
      businessType: 'Distributor'
    }
  ];

  // Star rating component
  const StarRating = ({ rating }) => {
    return (
      <div className="testimonial-stars">
        {[...Array(5)].map((_, i) => (
          <span key={i} className={i < rating ? 'star-filled' : 'star-empty'}>★</span>
        ))}
      </div>
    );
  };

  // Duplicate testimonials for seamless loop
  const allTestimonials = [...testimonials, ...testimonials];

  return (
    <>
      <section id="testimonials" className="testimonials-section">
        <div className="testimonials-container">
          
          {/* Section Header */}
          <div className="testimonials-header">
            <span className="testimonials-tagline">Trusted by Industry Leaders</span>
            <h2 className="testimonials-title">
              What Our <span className="testimonials-highlight">Partners Say</span>
            </h2>
            <div className="testimonials-underline"></div>
            <p className="testimonials-subtitle">
              Don't just take our word for it. Here's what hearing care professionals and distributors say about us.
            </p>
          </div>

          {/* Single Marquee - Right to Left */}
          <div className="testimonials-marquee">
            <div className="testimonials-marquee-track">
              {allTestimonials.map((testimonial, index) => (
                <div key={`${testimonial.id}-${index}`} className="testimonial-card">
                  <div className="testimonial-card-inner">
                    <div className="testimonial-quote-icon">"</div>
                    <StarRating rating={testimonial.rating} />
                    <p className="testimonial-text">{testimonial.text}</p>
                    <div className="testimonial-author">
                      <div className="testimonial-avatar">
                        <div className="testimonial-avatar-placeholder">
                          {testimonial.name.charAt(0)}
                        </div>
                      </div>
                      <div className="testimonial-info">
                        <h4>{testimonial.name}</h4>
                        <p>{testimonial.position}</p>
                        <span className="testimonial-location">{testimonial.location}</span>
                      </div>
                    </div>
                    <div className="testimonial-badge">{testimonial.businessType}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Stats Summary */}
          <div className="testimonials-stats">
            <div className="testimonials-stat-item">
              <span className="testimonials-stat-number">50+</span>
              <span className="testimonials-stat-label">Happy Partners</span>
            </div>
            <div className="testimonials-stat-divider"></div>
            <div className="testimonials-stat-item">
              <span className="testimonials-stat-number">98%</span>
              <span className="testimonials-stat-label">Satisfaction Rate</span>
            </div>
            <div className="testimonials-stat-divider"></div>
            <div className="testimonials-stat-item">
              <span className="testimonials-stat-number">4.9/5</span>
              <span className="testimonials-stat-label">Average Rating</span>
            </div>
          </div>

          {/* CTA */}
          <div className="testimonials-cta">
            <p>Join 50+ successful partners across India</p>
            <button onClick={openQuoteModal} className="testimonials-cta-btn">
              Become Our Partner →
            </button>
          </div>

        </div>
      </section>

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </>
  );
};

export default Testimonials;